import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { first, mergeMap, tap } from 'rxjs/operators';
import { AppSandbox } from '../app.sandbox';
import { CorporateClientState } from '../../statemanagement/corporate-client.state';

@Injectable()
export class CorporateClientInterceptor implements HttpInterceptor {
    constructor(private store: Store<{ corporateClient: CorporateClientState }>,
                private appSandbox: AppSandbox) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const nonCorporateClientUrls = ['auth/login', 'corporate-clients', 'prospects', 'translations'];
        if (!nonCorporateClientUrls.some(x => req.url?.indexOf(x) >= 0)) {
            return this.store.pipe(
                select('corporateClient'),
                first(),
                mergeMap((client: CorporateClientState) => {
                    const request = client && client.corporateClientId
                        ? req.clone({setHeaders: {'x-mysite-corporate-client-id': client.corporateClientId.toString()}})
                        : req;

                    return next.handle(request)
                        .pipe(tap(() => {}, err => {
                            if (err instanceof HttpErrorResponse && err.status === 401) {
                                this.appSandbox.logout();
                            }
                        }));
                })
            );
        } else {
            return next.handle(req);
        }
    }
}
